module.exports = __webpack_public_path__ + "img/thaiQrPayment.a687b140.svg";